const customerPlanEnum = Object.freeze({
  EXPIRED: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  CANCELED: 3,
})

export default customerPlanEnum
